import { useI18n, Trans } from '~/common/context';
import { IErrorApiResponse } from '@wyz/types';
import { Button, Flex, Modal } from '@wyz/ui';
import { PurchaseErrorCodesLookup } from '~/purchase/helpers';
import { PurchaseErrorCodeKeys } from '~/purchase/types';

type Props = {
  onClose: () => void;
  error: IErrorApiResponse<
    unknown,
    PurchaseErrorCodeKeys,
    { stock: number }
  > | null;
};
const AddToCartFailureModal = ({ onClose, error }: Props) => {
  const { t } = useI18n();
  return (
    <Modal.Container open={true} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey='app.purchase.search_page.add_cart_errors.title' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <div>
            <Trans
              i18nKey={PurchaseErrorCodesLookup[error.message]}
              values={{
                quantity: error?.meta?.stock,
              }}
            />
          </div>
        ) : (
          t('app.common.messages.error')
        )}
      </Modal.Body>
      <Modal.Footer>
        <Flex className='center space-x-2'>
          <Button
            id='close-modal'
            variant='danger'
            className='mx-2'
            onClick={onClose}
          >
            <Trans i18nKey='app.common.button.close' />
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal.Container>
  );
};

export default AddToCartFailureModal;
